export default __webpack_public_path__ + "static/niche@768_2x-84c88e284fb71013ecc34506207681c5.png";